
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_z75md_97",
  "arrow": "awsui_arrow_18eso_z75md_97",
  "has-caret": "awsui_has-caret_18eso_z75md_159",
  "placeholder": "awsui_placeholder_18eso_z75md_162",
  "pressed": "awsui_pressed_18eso_z75md_175",
  "disabled": "awsui_disabled_18eso_z75md_178",
  "in-filtering-token": "awsui_in-filtering-token_18eso_z75md_187",
  "read-only": "awsui_read-only_18eso_z75md_193",
  "invalid": "awsui_invalid_18eso_z75md_210",
  "inline-tokens": "awsui_inline-tokens_18eso_z75md_245"
};
  